"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreNumberBadge = _interopRequireDefault(require("@legacy-vfuk/core-number-badge"));

var Styled = _interopRequireWildcard(require("./styles/IconAppCloudDvr.style"));

var _ruleSet = require("../../ruleSet");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconAppCloudDvr = function IconAppCloudDvr(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
      _ref$isResponsive = _ref.isResponsive,
      isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      state = _ref.state,
      numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.793 18.5s2.805.11 3.898-.375a4.78 4.78 0 0 0 2.786-3.875c.164-1.637-.582-3.434-1.993-4.3-.699-.434-1.52-.61-2.34-.68a9.858 9.858 0 0 0-1.398.062 5.463 5.463 0 0 0-4.738-3.82 5.312 5.312 0 0 0-4.465 1.89A5.502 5.502 0 0 0 5.43 9.586c-.055.21-.16.805-.16.805a4.188 4.188 0 0 0-1.485.843C2.473 12.41 2.152 14.418 2.887 16c.668 1.434 2.101 2.5 3.695 2.5Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.5 12.316v3.414a.3.3 0 0 0 .293.301.286.286 0 0 0 .191-.058l.043-.028 2.274-1.625.066-.05a.259.259 0 0 0 .125-.172.27.27 0 0 0-.035-.211l-.004-.012a.289.289 0 0 0-.09-.078l-.062-.047-2.266-1.625a.327.327 0 0 0-.348-.07.308.308 0 0 0-.187.285v.023m7.012-.332v4m2-4v4",
    vectorEffect: "non-scaling-stroke"
  }))), numberBadge && /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })));
};

IconAppCloudDvr.displayName = "IconAppCloudDvr";
var _default = IconAppCloudDvr;
exports["default"] = _default;
//# sourceMappingURL=IconAppCloudDvr.js.map